import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder, getTicketTypeById, getTicketTypeInfosByTicketTypeId, getCountries } from "ticketino-api-client";

import imgIconDelete from "../images/icons/delete.svg";

import Header from "./components/Header";
import Loading from "./components/Loading";

const Address = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [tickets, setTickets] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);

    const [eventIdWorkshopsSpecials, setEventIdWorkshopsSpecials] = useState();
    const [eventIdWorkshopsMasterclass, setEventIdWorkshopsMasterclass] = useState();

    const [addedPromotionCodes, setAddedPromotionCodes] = useState([]);

    const [isError, setIsError] = useState(false);

    const [loading, setLoading] = useState(false);

    const [buyerInfo, setBuyerInfo] = useState({
        firstName: "",
        name: "",
        street: "",
        city: "",
        postCode: "",
        countryId: 176,
        email: "",
        newsletter: false //stored on code1 of the buyer
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [countries, setCountries] = useState([]);

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);

                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }


        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId)
                } else {
                    sessionStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate(`/${language}/home`);
                }

                setOrganizerId(res.data.organizerId)
                setEventIdWorkshopsSpecials(res.data.eventIdWorkshopsSpecials)
                setEventIdWorkshopsMasterclass(res.data.eventIdWorkshopsMasterclass)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        // gtm - addPaymentInfo
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'addPaymentInfo'
        });
    }, [])


    // add promocodes to the summary if already existing in the order
    useEffect(() => {
        if (order && Array.isArray(order.tickets)) {
            const codes = [];
            order.tickets.forEach(ticket => {
                if (ticket.promotionCode && !codes.includes(ticket.promotionCode)) {
                    codes.push(ticket.promotionCode);
                }
            });

            if (codes.length !== addedPromotionCodes.length || !codes.every(c => addedPromotionCodes.includes(c))) {
                setAddedPromotionCodes(codes);
            }
        }
    }, [order]);

    useEffect(() => {
        requestResources();
        loadCountries();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadCountries = async () => {
        try {
            let countries = await getCountries(language);

            const indexCH = countries.findIndex(c => c.id === 176);
            const ch = countries[indexCH];
            countries.splice(indexCH, 1);

            var indexDE = countries.findIndex(c => c.id === 229);
            const de = countries[indexDE];
            countries.splice(indexDE, 1);

            var indexAU = countries.findIndex(c => c.id === 228);
            const au = countries[indexAU];
            countries.splice(indexAU, 1);

            var indexFR = countries.findIndex(c => c.id === 59);
            const fr = countries[indexFR];
            countries.splice(indexFR, 1);

            var indexIT = countries.findIndex(c => c.id === 87);
            const it = countries[indexIT];
            countries.splice(indexIT, 1);

            countries.unshift({ id: 0, name: "---------" });
            countries.unshift(it);
            countries.unshift(au);
            countries.unshift(fr);
            countries.unshift(de);
            countries.unshift(ch);

            setCountries(countries);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate(`/${language}/home`);
            }
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            // Check if updatedOrder or tickets is falsy before continuing
            if (!updatedOrder || !updatedOrder.tickets || updatedOrder.tickets.length === 0) {
                navigate(`/${language}/home`);
                return; // stop further execution
            }

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const info = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            );

            setTickets(updatedTickets);
            setOrder(updatedOrder);

            try {
                const address = await getAddressOfOrder(orderId);
                if (address) {
                    setBuyerInfo((prev) => ({
                        ...prev,
                        firstName: address.firstName ?? prev.firstName,
                        name: address.name ?? prev.name,
                        street: address.street ?? prev.street,
                        city: address.city ?? prev.city,
                        postCode: address.postCode ?? prev.postCode,
                        countryId: address.countryId ?? prev.countryId,
                        email: address.email ?? prev.email,
                        newsletter: address.code1 ? address.code1.trim().endsWith("true") : prev.newsletter,
                    }));
                }
            } catch (error) {
                // no address saved yet for this order - keep the empty defaults
            }

            // the backend doesn't reliably return the latest edit right after saving it,
            // so re-apply whatever this browser tab last submitted for this order on top
            try {
                const cachedBuyerInfo = JSON.parse(sessionStorage.getItem("buyerInfo"));
                if (cachedBuyerInfo) {
                    setBuyerInfo((prev) => ({ ...prev, ...cachedBuyerInfo }));
                }
            } catch (error) {
                // ignore malformed cache
            }
        }
        catch (error) {
            console.error(error);
        }
    };


    const removeTicketFromBasket = (id) => {
        let deleteBody = {
            ticketsToRemove: [id],
        };

        axios
            .delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                headers: {
                    Accept: "application/json",
                },
                data: deleteBody,
            })
            .then(() => loadOrder(orderId));
    }

    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };

    const formatDay = (isoString) => {
        const date = new Date(isoString);
        return String(date.getDate()).padStart(2, '0') + '.';
    };

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt, index) => {
                const isWorkshopTicket = tt.ticketType?.eventId === eventIdWorkshopsSpecials || tt.ticketType?.eventId === eventIdWorkshopsMasterclass;
                const displayPrice = isWorkshopTicket ? tt.ticketTypePrice + 15.00 : tt.ticketTypePrice;

                return (
                    <div key={tt.id}>
                        <div className="mt-3 d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center flex-nowrap">
                                <label className="ticket-name-label mb-0">
                                    1x {tt.info?.name}
                                </label>
                            </div>

                            <div className="d-flex align-items-center gap-2">
                                <label className="text-nowrap mb-0">
                                    {tt.ticketType?.currency} {displayPrice.toFixed(2)}
                                </label>
                                <button
                                    className="btn btn-link p-0 m-0 text-decoration-none"
                                    onClick={() => removeTicketFromBasket(tt.id)}
                                    aria-label="Remove ticket"
                                    style={{ outline: 'none', boxShadow: 'none' }}
                                >
                                    <img src={imgIconDelete} alt="delete" width="16" height="16" />
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })
        );
    };

    const onInputChange = (e) => {
        setBuyerInfo({ ...buyerInfo, [e.target.name]: e.target.value });
    };

    const onSubmit = async () => {
        const isValid = validateInputFields();

        if (!isValid) return;

        setLoading(true);

        await addAddressToBasket(buyerInfo.companion1firstname, buyerInfo.companion1lasttname);
    }

    const addAddressToBasket = async () => {

        let emailSalutation = buyerInfo.salutation;

        //workaround for german email salutation
        if (emailSalutation === "Herr") {
            emailSalutation = resources?.BuyerSalutationMrValue;
        } else if (emailSalutation === "Frau") {
            emailSalutation = resources?.BuyerSalutationMsValue;
        } else if (emailSalutation === "Divers") {
            emailSalutation = resources?.BuyerSalutationDiverseValue;
        }

        let addressBody = {
            firstName: buyerInfo.firstName,
            name: buyerInfo.name,
            street: buyerInfo.street,
            city: buyerInfo.city,
            postCode: buyerInfo.postCode,
            countryId: buyerInfo.countryId,
            email: buyerInfo.email,
            code1: `Newsletter Weinfestivals: ${buyerInfo.newsletter}`,
        };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => {

                // remember the last submitted address for this order, in case the
                // backend doesn't return the latest edit when we fetch it back
                sessionStorage.setItem("buyerInfo", JSON.stringify(buyerInfo));

                // gtm - addAddress
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'addAddress'
                });

                // Check if all tickets have no additionalFields or empty additionalFields array
                const noAdditionalFields = tickets?.every(
                    (t) => !t.ticketType?.additionalFields || t.ticketType.additionalFields.length === 0
                );

                if (noAdditionalFields) {
                    navigate(`/${language}/checkout`);
                    return;
                } else {
                    navigate(`/${language}/workshop-ticket`)
                }
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/home`)
            });
    };

    const validateInputFields = () => {

        let validation =
            buyerInfo.firstName && /^.{1,70}$/.test(buyerInfo.firstName) &&
            buyerInfo.name && /^.{1,70}$/.test(buyerInfo.name) &&
            buyerInfo.email && /^\S+@\S+\.\S+$/.test(buyerInfo.email);

        setIsError(!validation);
        return validation;

    }

    const onBackClick = async () => {
        navigate(-1)
    }

    return (
        <>
            {loading ? (
                <>
                    <Loading
                        alignment="center"
                        color="#d3d3d3"
                        bgColor="transparent"
                        top="50%"
                        resources={resources}
                    />
                </>
            ) : (
                <>
                    <Header language={language} pagePath="address" />
                    <div className="page-container">

                        <div className="container wrapper">

                            {/* intro */}
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="text-title">{resources?.HomeTitle}</h1>
                                </div>
                            </div>

                            {/* overview of the order */}
                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <span className="text-title">{resources?.OverviewTitle}</span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    {mapTickets()}
                                </div>
                            </div>

                            <hr className="ticket-separator" />

                            {addedPromotionCodes.length > 0 &&
                                <div className="row pt-2 pb-1">
                                    <div className="col-md-8 col-8">
                                        <label>{resources?.PromotionCodes}</label>
                                    </div>
                                    <div className="col-md-4 col-4 text-end">
                                        <label>{addedPromotionCodes.join(", ")}</label>
                                    </div>
                                </div>
                            }

                            <div className="row">
                                <div className="col-md-8 col-8">
                                    <span>{resources?.OverviewTotal}</span>
                                </div>
                                <div className="col-md-4 col-4 text-end">
                                    <span>{order.currency} {order.totalPrice?.toFixed(2)}</span>
                                </div>
                            </div>

                            <div className="row mt-5">
                                <div className="col-md-12">
                                    <span className="text-title">{resources?.BuyerPleaseFill}</span>
                                </div>
                            </div>

                            <div className="mt-1">
                                {/* Buyer */}
                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="firstName"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerFirstname}
                                            value={buyerInfo.firstName}
                                            id="firstName"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerLastname}
                                            value={buyerInfo.name}
                                            id="name"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                {/*<div className="mb-4 row">*/}
                                {/*    <div className="col-md-12">*/}
                                {/*        <input*/}
                                {/*            type="text"*/}
                                {/*            name="street"*/}
                                {/*            className="form-control mt-2"*/}
                                {/*            placeholder={resources?.BuyerStreet}*/}
                                {/*            value={buyerInfo.street}*/}
                                {/*            id="street"*/}
                                {/*            onChange={onInputChange}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                {/*<div className="mb-4 row">*/}
                                {/*    <div className="col-md-12">*/}
                                {/*        <input*/}
                                {/*            type="text"*/}
                                {/*            name="postCode"*/}
                                {/*            className="form-control mt-2"*/}
                                {/*            placeholder={resources?.BuyerPostcode}*/}
                                {/*            value={buyerInfo.postCode}*/}
                                {/*            id="postCode"*/}
                                {/*            onChange={onInputChange}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                {/*<div className="mb-4 row">*/}
                                {/*    <div className="col-md-12">*/}
                                {/*        <input*/}
                                {/*            type="text"*/}
                                {/*            name="city"*/}
                                {/*            className="form-control mt-2"*/}
                                {/*            placeholder={resources?.BuyerCity}*/}
                                {/*            value={buyerInfo.city}*/}
                                {/*            id="city"*/}
                                {/*            onChange={onInputChange}*/}
                                {/*        />*/}
                                {/*    </div>*/}
                                {/*</div>*/}

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerEmail}
                                            value={buyerInfo.email}
                                            id="email"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                {/* newsletter */}
                                <div className="mb-4 row">
                                    <div className="col-md-12 d-flex align-items-center">
                                        <input
                                            type="checkbox"
                                            name="newsletter"
                                            className="form-check-input mt-0 me-3"
                                            id="newsletter"
                                            checked={buyerInfo.newsletter}
                                            onChange={(e) => setBuyerInfo({ ...buyerInfo, newsletter: e.target.checked })}
                                        />
                                        <label className="cursor-pointer mb-0" htmlFor="newsletter">
                                            {resources?.BuyerNewsletter}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-6">
                                    <button className="btn btn-custom" onClick={() => navigate(-1)}>{resources?.Back}</button>
                                </div>
                                <div className="col-6 text-end">
                                    <button className="btn btn-custom" onClick={() => onSubmit()}>{resources?.Next}</button>
                                </div>
                            </div>


                            {isError &&
                                <div className="row text-start mt-2">
                                    <p className="text-error">{resources?.ErrorPleaseFillMandatoryFields}</p>
                                </div>
                            }

                            <div className="row mt-5">
                                <div className="col-md-12 text-center">
                                    <p className="mt-4">
                                        <small className="powered-by">powered by <a href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default Address